import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ViewEncapsulation } from '@angular/core';
import { scaleIn } from '../../shared/animations/modal.animation';

@Component({
  selector: 'app-social-register',
  templateUrl: './social-register.component.html',
  styleUrls: ['./social-register.component.css'], 
  animations: [scaleIn], 
  encapsulation: ViewEncapsulation.None 
})
export class SocialRegisterComponent implements OnInit {
  @Input() visible: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
